const CONFIG = {
    API_PATH: `${process.env.REACT_APP_APPLICATION_SERVICES}/api`,
    DATE_TIME_FORMAT: 'ddd MMM DD YYYY HH:mm:ss',
    LOCKED_STAGES: ["Production", "PreProduction", "ValidationTest", "Test", "Uat"],
};

export default CONFIG;